import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { AgrimotorService } from '../../../quote/agrimotor/agrimotor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from 'src/app/quote/quote.service';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-ag-policy',
  templateUrl: './ag-policy.component.html',
  styleUrls: ['./ag-policy.component.css']
})
export class AgPolicyComponent implements OnInit {
  staticData;
  id = this.route.snapshot.params.quote_id;
  constructor(private as: AgrimotorService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal,
    private quoteService: QuoteService, private formBuilder: FormBuilder, private el: ElementRef, private sessionSt: LocalStorageService) { }

  minCacellationDate = new Date();
  maxCacellationDate = new Date();
  isAdmin: boolean = false;

  ngOnInit(): void {
    this.getAccessToken();
    this.getQuote();
    let minDate = new Date().setDate(new Date().getDate());
    this.minCacellationDate = new Date(minDate);
    let maxDate = new Date().setDate(new Date().getDate() + 30);
    this.maxCacellationDate = new Date(maxDate);

    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
  }

  authDetails: string = '';
  getAccessToken() {
    let data = {
      'client_id': environment.AGRIMOTOR_CLIENT_ID,
      'client_secret': environment.AGRIMOTOR_CLIENT_SECRET,
      'grant_type': environment.AGRIMOTOR_GRANT_TYPE,
      'scope': environment.AGRIMOTOR_SCOPE,
    };
    this.as.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData(response);
          }
        },
        (error) => { }
      );
  }

  getStaticData(authDetails) {
    this.as.getStaticData(authDetails)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => { }
      );
  }

  quoteDetails;
  policyID: string = '';
  getQuote() {
    this.as.getAgrimotorData(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          this.policyID = response.result.quote_data.quote_versions[0].agriculture_data.data.id;
          this.quoteDetails = response.result.quote_data.quote_versions[0].agriculture_data.data.attributes;
          this.quoteDetails.insurance_status_id = response.result.quote_data.insurance_status_id;
          this.quoteDetails.id = response.result.quote_data.quote_versions[0].id;
          this.quoteDetails.type = response.result.quote_data.quote_versions[0].type;
          this.quoteDetails.broker_id = response.result.quote_data.quote_versions[0].broker_id;
          this.quoteDetails.company_id = response.result.quote_data.quote_versions[0].company_id;
          this.quoteDetails.agrimotor_policy_reference = response.result.quote_data.quote_versions[0].agrimotor_policy_reference;
          if (response.result.quote_data.quote_versions[0].financial_details) {
            this.quoteDetails.peliwica_fee = response.result.quote_data.quote_versions[0].financial_details.fees;
            this.quoteDetails.broker_commission = response.result.quote_data.quote_versions[0].financial_details.broker_commission;
            this.quoteDetails.broker_admin_fee = response.result.quote_data.quote_versions[0].financial_details.broker_admin_fee;
          } else {
            this.quoteDetails.peliwica_fee = 0;
            this.quoteDetails.broker_commission = 0;
            this.quoteDetails.broker_admin_fee = 0;
          }
          this.quoteDetails.notes = response.result.quote_data.quote_versions[0].notes;
          this.quoteDetails.is_policy = response.result.quote_data.quote_versions[0].is_policy;
          this.quoteDetails.email = response.result.quote_data.quote_versions[0].policy_holder?.email;
          this.quoteDetails.phone = response.result.quote_data.quote_versions[0].policy_holder?.phone;
          this.quoteDetails.is_email = response.result.quote_data.quote_versions[0].policy_holder?.is_email;
          this.quoteDetails.is_phone = response.result.quote_data.quote_versions[0].policy_holder?.is_phone;
          this.quoteDetails.sms = response.result.quote_data.quote_versions[0].policy_holder?.sms;
          this.quoteDetails.post = response.result.quote_data.quote_versions[0].policy_holder?.post;
          this.quoteDetails.is_paid = response.result.quote_data.quote_versions[0].is_paid;
          this.quoteDetails.paid_date = response.result.quote_data.quote_versions[0].paid_date;
          this.quoteDetails.bank_payment_date = response.result.quote_data.quote_versions[0].bank_payment_date;
          this.quoteDetails.transactional_date = response.result.quote_data.quote_versions[0].transactional_date;
          this.quoteDetails.is_send_email = response.result.quote_data.quote_versions[0].is_send_email;
          this.quoteDetails.product_id = response.result.quote_data.quote_versions[0].product_id;
          this.quoteDetails.agriculture_policy_reference = response.result.quote_data.quote_versions[0].agriculture_policy_reference;
          const appVehicles = this.quoteDetails.application?.vehicles;
          if (appVehicles && appVehicles.length > 0) {
            this.quoteDetails.cars = appVehicles.filter((v: any) => v.type === 'cars');
            this.quoteDetails.commercial_vehicles = appVehicles.filter((v: any) => v.type === 'commercial');
            this.quoteDetails.agricultural_vehicles = appVehicles.filter((v: any) => v.type === 'agricultural');
            this.quoteDetails.horseboxes = appVehicles.filter((v: any) => v.type === 'horsebox' || v.type === 'horseboxes');
            this.quoteDetails.trailers = appVehicles.filter((v: any) => v.type === 'trailer' || v.type === 'trailers');
          }
          this.getQuoteNotes();
        },
        (error) => { }
      );
  }

  issueQuotePopup(issueQuoteModal) {
    this.modalService.open(issueQuoteModal, { centered: true });
  }

  issueQuote() {
    let data = { "agriculture_quote_id": this.route.snapshot.params.quote_id };
    this.as.issueQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.modalService.dismissAll();
            this.router.navigateByUrl("/policy-list");
          }
        });
  }

  hasImportantNotes: boolean = false;
  totalImpNotes: number = 0;
  getQuoteNotes() {
    this.quoteService.getNotes(this.quoteDetails.id)
      .subscribe(
        (response: any) => {
          let impNotes = response.result.filter(x => x.is_important == 1);
          this.totalImpNotes = impNotes.length;
          if (impNotes.length > 0) {
            this.hasImportantNotes = true;
          }
        });
  }

  onhasImportantNotesChange(event) {
    this.hasImportantNotes = event;
    this.totalImpNotes = this.totalImpNotes + 1;
  }

  policyActions(type) {
    this.router.navigateByUrl("/agrimotor/quote/" + this.id + '/' + type);
  }

  submitted: boolean = false;
  cancellation_date;
  cancellation_reason;
  refund_amount;
  cancelPolicy(cancelModal: any) {
    this.modalService.open(cancelModal, { centered: true });
  }

  errorMsg: string = '';
  getReturnPremium() {
    this.errorMsg = null;
    if (this.cancellation_date && this.cancellation_reason) {
      this.refund_amount = null;
      let data = {
        'meta': {
          "effective_date": formatDate(this.cancellation_date, 'yyyy-MM-dd', 'en-UK'),
          "reason": this.cancellation_reason,
        }
      };
      this.as.getReturnPremium(data, this.policyID, this.authDetails)
        .subscribe(
          (res: any) => {
            if (res) {
              if (res.meta) {
                this.refund_amount = res.meta.return_premium;
              }
            }
          }, err => {
            if (err.error.errors && err.error.errors.length > 0) {
              this.errorMsg = err.error.errors[0].detail;
            }
          });
    }
  }

  onSubmitCancelPolicy() {
    this.submitted = true;
    let data = {
      'meta': {
        "effective_date": formatDate(this.cancellation_date, 'yyyy-MM-dd', 'en-US'),
        "reason": this.cancellation_reason,
        "return_premium": this.refund_amount,
      }
    };
    this.as.getCancelPolicy(data, this.policyID, this.authDetails)
      .subscribe(
        (res: any) => {
          if (res) {
            this.modalService.dismissAll();
            this.getQuote();
          }
        }, err => {
          if (err.error.errors && err.error.errors.length > 0) {
            this.errorMsg = err.error.errors[0].detail;
          }
        });
  }

  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;
  newEmailView() { this.displayNewEmailView = true; }

  email_id: string = '';
  getEmailView(email_id) { this.email_id = email_id; this.displayEmailView = true; }
  backToEmailsList() { this.displayEmailView = false; this.displayNewEmailView = false; }
}
